import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { FilterableMenuItem, FilterableMenuItemArgs, DisplayOption } from 'owa-filterable-menu';
import { getNonCategoryMenuItems } from './getNonCategoryMenuItems';
import { getCategoriesMenuItems } from './getCategoriesMenuItems';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { filterMenuText } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import styles from './filterMenuItem.scss';
import { logUsage } from 'owa-analytics';

export function getFilterMenuItem() {
    const filterMenuItemList: IContextualMenuItem[] = [
        ...getNonCategoryMenuItems(),
        ...getCategoriesMenuItems(),
    ];

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(filterMenuText),
        [FilterableMenuItemArgs.title]: loc(filterMenuText),
        [FilterableMenuItemArgs.icon]: ControlIcons.Filter,
        [FilterableMenuItemArgs.subMenuProps]: {
            items: filterMenuItemList,
            onMenuOpened: () => {
                logUsage('CalendarEventsFilterMenuOpened');
            },
            calloutProps: {
                styles: {
                    calloutMain: styles.filterMenu,
                },
            },
        },
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
    });
}
